"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegendMixin = void 0;
var LegendMixin = function LegendMixin() {
  return "\n    && {\n        cursor: default;\n    }\n";
};
exports.LegendMixin = LegendMixin;